import { GrClose } from "react-icons/gr";
import { Modal, ModalBody, ModalHeader } from "reactstrap";

const CommonModal = ({
  isOpen,
  handleClose,
  className,
  subTitle,
  title,
  btnText = "Save",
  modalProps = {},
  children,
  maxWidth,
  onWheel,
}) => {
  const closeBtn = (
    <div className="gr-close-icon" onClick={handleClose}>
      <GrClose size={20} />
    </div>
  );
  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={handleClose}
        className={`${className} modal-styles `}
        {...modalProps}
        centered
        style={{ maxWidth: maxWidth }}
        onWheel={onWheel}
      >
        <ModalHeader
          toggle={handleClose}
          close={closeBtn}
          style={{ borderBottom: "none" }}
          className="header-title"
        >
          {title}
        </ModalHeader>
        <ModalBody>{children}</ModalBody>
      </Modal>
    </div>
  );
};

export default CommonModal;
